/* let's build the custom element  */
class JourneyTracker extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleRemoveClick.bind(this));
    const popup = document.querySelector('#tracking-popup');
    const journey_start_with_fullback = this.getAttribute('data-reset-journey-full-back');
    const closeJourneyButton = document.querySelector('[data-close-journey]');
    const continueJourneyButton = document.querySelector('[data-continue-journey]');
    const cartAttributes = this.getAttribute('data-cart-attributes');
    this.cartAttributesObject = JSON.parse(cartAttributes);
    this.continueUrl = this.getContinueUrl(this.cartAttributesObject);
    const modalCloseButton = document.querySelector('#tracking-popup .cc-popup-close');

    //debugger;
    // now popup we directly start new journey
    if (popup && journey_start_with_fullback) {
      const popupInstance = new ccPopup($('#tracking-popup'), '#journey-tracker');
      //this.startNewJourneyCallback(journey_start_with_fullback);
      // we hide the popup for now
      //popupInstance.open();
      this.startNewJourneyCallback(journey_start_with_fullback);
      closeJourneyButton.addEventListener('click', () => {
        popupInstance.close();
        //this.startNewJourneyCallback(journey_start_with_fullback);
      });
      modalCloseButton.addEventListener('click', () => {
        popupInstance.close();
        this.startNewJourneyCallback(journey_start_with_fullback);
      });
      continueJourneyButton.addEventListener('click', () => {
        window.location.href = this.continueUrl;
      });
    }
  }

  async startNewJourneyCallback(journey_start_with_fullback) {
    await this.resetJourneyFromFullback(journey_start_with_fullback);
    const shapesInputs = document.querySelectorAll('.shapes__list input');
    const urlBasedShape = document.querySelector('diamonds-search').dataset.ring_shape;
    const isUrlBasedShape = document.querySelector('diamonds-search').hasAttribute('data-url-based-shape');
    if (this.cartAttributesObject.ring_handle) {
      shapesInputs.forEach((input) => {
        input.setAttribute('type', 'checkbox');
        input.checked = false;
        input.disabled = false;
        if (input.value.toLowerCase() == urlBasedShape?.toLowerCase() && isUrlBasedShape) {
          input.checked = true;
        }
        input.dispatchEvent(new Event('change'));
      });
    }
  }

  getContinueUrl() {
    let url = '';
    if (this.cartAttributesObject.diamond_handle && this.cartAttributesObject.ring_handle) {
      url = window.complete_engagement_ring_url;
    } else if (this.cartAttributesObject.diamond_handle && this.cartAttributesObject.diamond_shape) {
      let shape = (this.cartAttributesObject.diamond_shape ? this.cartAttributesObject.diamond_shape : 'round').replaceAll(' ', '_').toLowerCase().trim();
      const shapeCollectionUrl = window[`${shape}_collection_url`] + `?journey_start_with=diamond`;
      url = shapeCollectionUrl;
    } else if (this.cartAttributesObject.ring_handle && this.cartAttributesObject.ring_shape) {
      url = window.lapgrown_search_page_url + `?journey_start_with=setting`;
    }
    return url;
  }

  static showOverlay({ msg = `Updating your selection` } = {}) {
    const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
    const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
    if (msgEl) {
      msgEl.textContent = msg;
    }
    if (overlay) {
      overlay.style.display = 'block';
    }
  }

  updateQueryParam(url, key, value) {
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set(key, value);
    return urlObj.toString();
  }

  handleRemoveClick(event) {
    const target = event.target;
    if (target.classList.contains('journey-tracker__link') && target.hasAttribute('data-clear-attributes')) {
      event.preventDefault();
      const attrsToClear = target.getAttribute('data-clear-attributes');
      JourneyTracker.showOverlay();
      const url = target.href;
      let updatedUrl = this.getClearUrl(attrsToClear, target.href);
      let ringShape = (this.cartAttributesObject.ring_shape || '').replaceAll(' ', '_').toLowerCase().trim();
      let diamondShape = (this.cartAttributesObject.diamond_shape || '').replaceAll(' ', '_').toLowerCase().trim();
      if (attrsToClear.includes('ring_handle')) {
        if (diamondShape && window[`${diamondShape}_collection_url`]) {
          const shapeCollectionUrl = window[`${diamondShape}_collection_url`];
          updatedUrl = shapeCollectionUrl;
        } else {
          updatedUrl = window.rings_collection_url;
        }
      } else if (attrsToClear.includes('diamond_handle')) {
        if (ringShape) {
          updatedUrl = this.updateQueryParam(url, 'journey_start_with', '');
        } else {
          updatedUrl = window.rings_collection_url;
        }
      }
      this.clearAttributes(attrsToClear).then(() => {
        window.location.href = updatedUrl;
      });
    }
  }

  // takes comma separated string of attributes to clear
  async clearAttributes(attrNames) {
    const attrs = {
      attributes: {
        ...attrNames.split(',').reduce((acc, attr) => {
          acc[attr] = '';
          return acc;
        }, {}),
      },
    };
    /* 
    if (attrNames.includes('ring_handle')) {
      attrs.attributes.journey_start_with = 'diamond';
    } else if (attrNames.includes('diamond_handle')) {
      attrs.attributes.journey_start_with = 'setting';
    } */

    await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      body: JSON.stringify(attrs),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  }

  async resetJourneyFromFullback(journey_start_with_fullback) {
    //return;
    window.journey_start_with_fullback = journey_start_with_fullback;
    const attrs = {
      attributes: {
        journey_start_with: journey_start_with_fullback,
        ring_shape: '',
        ring_metal: '',
        ring_handle: '',
        ring_variant_id: '',
        ring_Finger_size: '',
        ring_timestamp: '',
        diamond_handle: '',
        diamond_shape: '',
        diamond_timestamp: '',
        journey_started_at: window.theme.server_time,
      },
    };

    await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      body: JSON.stringify(attrs),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  }

  getClearUrl(attrsToClear, targetUrl) {
    let url = '';
    if (attrsToClear.includes('ring_handle')) {
      let shape = (this.cartAttributesObject.diamond_shape ? this.cartAttributesObject.diamond_shape : 'round').replaceAll(' ', '_').toLowerCase().trim();
      const shapeCollectionUrl = window[`${shape}_collection_url`];
      url = shapeCollectionUrl;
    } else if (attrsToClear.includes('diamond_handle')) {
      url = targetUrl;
    }
    return url;
  }
}

customElements.define('journey-tracker', JourneyTracker);
